export const EvidencijeResourcesEN: EvidencijeResourcesBSInterface = {
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  odabirPoljaEvidencije: {
    title: "Select Evidence Fields",
    buttonForward: "Add",
    buttonBack: "Back",
    dropdownPlaceholder: "Select evidence field",
    successModal: {
      title: "Data Entry",
      body: "Data addition has been successfully completed. Select OK to continue.",
      buttonOk: "OK",
    },
    poljaEvidencije: {
      CIPP_V1: "Cleaning and washing premises v1",
      CIPO_V1: "Cleaning and washing equipment v1",
      Dezinfekcija_V1: "Disinfection v1",
      Dezinsekcija_V1: "Pest control v1",
      Dezinsekcija_V1_Kontrola: "Pest control control v1",
      Dezinsekcija_V1_Korekcija: "Pest control correction v1",
      Deratizacija_V1: "Rodent control v1",
      Deratizacija_V1_Kontrola: "Rodent control control v1",
      Deratizacija_V1_Korekcija: "Rodent control correction v1",
      DezSr_V1: "Disinfection products v1",
      Dobavljac_V1: "Suppliers v1",
      Dostava_V1: "Delivery / Goods Receipt v1",
      EduZap_V1: "Employee education v1",
      Mol_V1: "Painting work v1",
      Oprema_V1: "Equipment v1",
      Otpad_V1: "Waste v1",
      PrijemRobe_V1: "Goods receipt v1",
      San_V1: "Sanitary inspection v1",
      Temperatura_V1: "Temperature lists v1",
      TemperaturaOgranicenaEvd_V1: "Temperature lists - limited v1",
      TemperaturaOgranicenaKKTEvd_V1: "Temperature lists - limited - KKT - v1",
      TemperaturaKKTProizvodiEvd_V1: "Temperature lists - products - KKT v1",
      FeedbackEvd_V1: "Feedback evidence v1",
    },
  },
  evidencije: {
    notAllowed: "You do not have sufficient rights to fill out this evidence.",
    tackePrimjene: (count: number) => (
      <>Application points: Selected: {count}</>
    ),
    ucestalost: (type: string, count: number) => (
      <>
        Frequency: Selected {type} ({count})
      </>
    ),
    odgovorneOsobe: (count: number) => (
      <>Responsible persons: Selected category ({count})</>
    ),
    poljaEvidencije: (polja: string) => {
      return <>{`Evidence fields: ${polja}`}</>;
    },
    nextButton: "Fill evidence",
    backButton: "Back",
    saveButton: "Sign",
    deleteButton: "Delete evidence",
    deleteModal: {
      title: "Delete confirmation",
      message:
        "Are you sure you want to delete this evidence? This action cannot be undone.",
      confirmButton: "Yes, delete",
      cancelButton: "Cancel",
      successTitle: "Successfully deleted",
      successMessage: "Evidence has been successfully deleted.",
      successButton: "Close",
    },
    deleteSuccess: "Evidence successfully deleted.",
    deleteError: "Error deleting evidence.",
    deselectAll: "Deselect all",
    noActiveRecords: {
      title: "No active evidence",
      message:
        "For the scanned application point, there are no active evidence records that need to be filled out.",
      suggestion:
        "The evidence has already been filled out for today. Please check the date range or contact the administrator.",
    },
  },
};

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface PoljaEvidencije {
  CIPP_V1: string;
  CIPO_V1: string;
  Dezinfekcija_V1: string;
  Dezinsekcija_V1: string;
  Dezinsekcija_V1_Kontrola: string;
  Dezinsekcija_V1_Korekcija: string;
  Deratizacija_V1: string;
  Deratizacija_V1_Kontrola: string;
  Deratizacija_V1_Korekcija: string;
  DezSr_V1: string;
  Dobavljac_V1: string;
  Dostava_V1: string;
  EduZap_V1: string;
  Mol_V1: string;
  Oprema_V1: string;
  Otpad_V1: string;
  PrijemRobe_V1: string;
  San_V1: string;
  Temperatura_V1: string;
  TemperaturaOgranicenaEvd_V1: string;
  TemperaturaOgranicenaKKTEvd_V1: string;
  TemperaturaKKTProizvodiEvd_V1: string;
  FeedbackEvd_V1: string;
}

interface OdabirPoljaEvidencije {
  title: string;
  buttonForward: string;
  buttonBack: string;
  dropdownPlaceholder: string;
  successModal: SuccessModal;
  poljaEvidencije: PoljaEvidencije;
}

interface DeleteModal {
  title: string;
  message: string;
  confirmButton: string;
  cancelButton: string;
  successTitle?: string;
  successMessage?: string;
  successButton?: string;
}

interface NoActiveRecords {
  title: string;
  message: string;
  suggestion: string;
}

interface Evidencije {
  notAllowed: string;
  tackePrimjene: (count: number) => JSX.Element;
  ucestalost: (type: string, count: number) => JSX.Element;
  odgovorneOsobe: (count: number) => JSX.Element;
  poljaEvidencije: (polja: string) => JSX.Element;
  nextButton: string;
  backButton: string;
  saveButton: string;
  deleteButton: string;
  deleteModal: DeleteModal;
  deleteSuccess: string;
  deleteError: string;
  deselectAll: string;
  noActiveRecords: NoActiveRecords;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface EvidencijeResourcesBSInterface {
  odabirPoljaEvidencije: OdabirPoljaEvidencije;
  evidencije: Evidencije;
  errors: IErrors;
}
